// Copyright (c) Bentley Systems
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { getParametersFromUrlString } from "../Helpers/helper-functions";
import Action from "./Action";
import { ActionVm } from "./action-vm";
import { ActionParameterVm } from "./action-parameter-vm";

const EiCall = () => {
  const { id, params } = useParams();
  const urlParameters = useMemo(
    () => getParametersFromUrlString(params),
    [params],
  );

  const action = useMemo(() => {
    const a = new ActionVm();
    a.isItemAction = true;
    urlParameters.forEach((p) => {
      const aPar = new ActionParameterVm();
      aPar.name = p.name;
      aPar.value = p.value;
      a.actionParameters.push(aPar);
    });
    a.targetNodeType = "EI";
    if (id !== undefined && !isNaN(+id)) {
      a.targetNodeId = Number(id);
    }
    return a;
  }, [id, urlParameters]);

  return (
    <div style={{ margin: 10 }}>
      <div>
        <Action
          isCalledDirectlyByUrl={true}
          key="eiCallAction"
          action={action}
        />
      </div>
    </div>
  );
};

export default EiCall;
